import React from "react";
import { Form, Input } from "antd";
import {
    MdModeEditOutline,
    MdClose,
} from "react-icons/md";
import ReactCodeInput from "react-code-input";

import classes from './Contact.module.scss'
import { phoneNumberModification } from '../../../../../services/generalService';

import SuccessIcon from '../../../../../assets/success.png'
import DangerIcon from '../../../../../assets/error.png'
import UnderlinedLink from "../../../../UI/UnderlinedLink/UnderlinedLink";
import SubmitButton from "../../../../UI/SubmitButton/SubmitButton";
import CountdownTimer from '../../../../UI/CountdownTimer/CountdownTimer';
import MobilePhoneInput from "../../../../UI/MobilePhoneInput/MobilePhoneInput";

const Contact = ({
    contact,
    contactSetEdit,
    cancelEdit,
    contactNewValue,
    contactNewValueOnChangeHandler,
    updateCreateContact,
    updateContactLoading,
    areEditButtonsVisible,
    phoneInputHandler,
    validateContactValue,

    isConfirmationCodeSend,
    sendConfirmationCode,
    isConfirmationCodeValid,
    confirmationCode,
    confirmationCodeLoading,
    setConfirmationCode,
    onCodeExpireHandler,
    numberOfAttempts,
    submitContact,
    submitContactLoading }) => {

    const CODE_LENGTH = 6
    const isValid = validateContactValue()

    const setConfirmButtons = () => {
        if (contact.ifEdit)
            return <SubmitButton
                block
                type="submit"
                text={areEditButtonsVisible ? "Сохранить" : "Привязать"}
                loading={updateContactLoading}
                onClickHandler={updateCreateContact}
                disabled={!isValid} />

        if (contact.confirmed)
            return <div className={classes.confirmedContactValue}>Контакт подтвержден</div>

        if (isConfirmationCodeSend && (contact.id === isConfirmationCodeSend?.contactId))
            return <SubmitButton
                block
                text="Отправить"
                loading={submitContactLoading}
                disabled={confirmationCode.length !== CODE_LENGTH}
                onClickHandler={submitContact} />

        else
            return <SubmitButton
                block
                text="Подтвердить"
                loading={confirmationCodeLoading}
                disabled={isConfirmationCodeSend && (contact.id !== isConfirmationCodeSend?.contactId)}
                onClickHandler={sendConfirmationCode} />
    }

    const setUpdateButtons = () => {
        if (areEditButtonsVisible) {
            if (!contact.ifEdit) return <button
                aria-label="edit contact"
                className={classes.editContactButton}
                onClick={contactSetEdit}>
                <MdModeEditOutline size={20} style={{ color: '#3d547e' }} />
            </button>
            else return <button
                aria-label=" cancel edit contact"
                className={classes.editContactButton}
                onClick={cancelEdit}>
                <MdClose size={20} />
            </button>
        } else return null
    }

    const setContactValue = () => {
        if (contact.contactTypeId === 4) return phoneNumberModification(contact.contactValue)
        else return contact.contactValue
    }

    const phoneInputOnKeyDownHandler = (e) => {
        if (isValid && e.key === 'Enter') updateCreateContact()
    }

    const getContactInput = () => {
        if (contact.contactTypeId === 4) {
            return <div style={contact.ifEdit ? {marginLeft: '38px'} : {}} className={classes.phoneInputContainer}>
                <MobilePhoneInput
                    className={(!isValid && contactNewValue.trim().length !== 0) ? classes.errorPhoneInput : classes.phoneInput}
                    phone={contactNewValue}
                    setPhoneValue={phoneInputHandler}
                    onKeyDown={(e) => phoneInputOnKeyDownHandler(e)}
                />
                <div className={classes.phoneHint}>
                    <b>yy</b> - код оператора (25, 29, 33, 44)<br/><b>xxx-xx-xx</b> - 7 цифр номера
                </div>
            </div>;
        } else {
            return <Form
                name="mask_recovery"
                scrollToFirstError={true}
                style={{width: '350px', maxWidth: 'calc(100% -200px)'}}
                onFinish={updateCreateContact}>
                <Form.Item
                    name="contact"
                    rules={contact.validationRules}
                    style={{marginBottom: '0'}}>
                    <Input
                        prefix={contact.icon}
                        autoComplete="off"
                        placeholder={`Введите ${contact.name.toLowerCase()}`}
                        value={contactNewValue}
                        onChange={contactNewValueOnChangeHandler}
                    />
                </Form.Item>
            </Form>;
        }
    }

    const setupContactValueContainer = () => {
        return <div
            style={contact.ifEdit && contact.contactTypeId === 4 ? {alignItems: 'flex-start'} : {}}
            className={classes.contactValueContainer}
        >
            {!contact.ifEdit
                ? <UnderlinedLink style={{height: 'fit-content'}} text={setContactValue()} href={`${contact.href}${contact.contactValue}`} />
                : getContactInput()}
            {!isConfirmationCodeSend && setUpdateButtons()}
        </div>
    }

    const setIconOffset = () => {
        let offset = 0
        if (contact.confirmed) offset = 3
        else offset = 6
        return { left: `${offset}px` }
    }

    return (<div className={classes.container}>
        <div className={classes.header}>
            {contact.confirmed
                ? <img src={SuccessIcon} width="155px" alt="confirmed contact icon" />
                : <img src={DangerIcon} width="150px" alt="not confirmed contact icon" />}
            <div style={setIconOffset()}>{contact.icon}</div>
        </div>

        <div className={classes.content}>
            <div className={classes.title}>{contact.name}</div>
            {setupContactValueContainer()}
        </div>

        {(isConfirmationCodeSend && (contact.id === isConfirmationCodeSend?.contactId)) &&
            <div className={classes.codeContainer}>
                <div key={isConfirmationCodeSend.expirationTime} className={classes.codeAndTimerContainer}>
                    <ReactCodeInput
                        id="confirmationCode"
                        type="number"
                        inputMode="numeric"
                        className={isConfirmationCodeValid ? classes.codeInputContainer : classes.codeInputContainerInvalid}
                        fields={CODE_LENGTH}
                        autoFocus={true}
                        disabled={!isConfirmationCodeSend}
                        isValid={isConfirmationCodeValid}
                        onChange={setConfirmationCode}
                        value={confirmationCode}
                    />
                    {(isConfirmationCodeSend.expirationTime > new Date().getTime()) && <div>
                        <CountdownTimer displayHours={false} targetDate={isConfirmationCodeSend.expirationTime} onExpireHandler={onCodeExpireHandler} />
                    </div>}
                </div>
                <div className={classes.attemptsContainer}>
                    {`Осталось попыток: `}
                    <span className={classes.errorMessage}>{numberOfAttempts}</span>
                </div>
                {isConfirmationCodeSend.expired && <div>
                    <SubmitButton
                        block
                        text="Запросить код повторно"
                        loading={confirmationCodeLoading}
                        disabled={isConfirmationCodeSend?.value && (contact.id !== isConfirmationCodeSend?.id)}
                        onClickHandler={sendConfirmationCode}
                    />
                </div>}
            </div>}

        <div className={classes.footer}>
            {setConfirmButtons()}
        </div>
    </div>)
}

export default Contact